import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";
import { SiteStoryTryTag } from "../SiteStoryTryTag";
import styles from "./SiteStoryStage.scss";

const msgKey = "siteStoryStage";

/**
 * Background of the interactive stories on the public pages: a soft glow with rings and sonar pulses behind the
 * story's boxes. Boxes can be positioned absolutely in it.
 * The center of the glow is at 58% from the left; move it with the `--story-center-x` CSS variable (in `className`).
 * @param onReset – the story can be tried: shows a "Try it" tag in the top left corner, which becomes a reset button
 * once it is `changed`. Leave it out to place a SiteStoryTryTag somewhere else.
 * @param changed – the visitor has changed something in the story
 * @param notLoaded – the story couldn't be shown (it crashed, or its content couldn't be loaded): shows a small
 * "Not loaded" text in the middle instead of the children
 */
export const SiteStoryStage = ({ onReset, changed, notLoaded, className, children }) => {
    return (
        <div className={classNames(styles.base, { [styles.notLoaded]: notLoaded }, className)}>
            <span className={styles.sonar} aria-hidden="true" />
            <span className={classNames(styles.sonar, styles.delayed)} aria-hidden="true" />
            {onReset ? <SiteStoryTryTag className={styles.tag} changed={changed} onReset={onReset} /> : null}
            {notLoaded ? (
                <span className={styles.notLoadedText}>
                    <FormattedMessage id={`${msgKey}.notLoaded`} />
                </span>
            ) : (
                children
            )}
        </div>
    );
};
